import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { StandardRequestBase } from '../../services/request-base';
import { DataCheck } from '../../workflow/workflow.dialog';
import { BaseListDetail, BaseListSettings, DeleteTexts, SaveTexts } from '../base.list.settings';

/**
 * Settings → AI knowledge: the project knowledge of this instance (KiWissenController). AI chats get
 * an overview when they connect and read and write it with the client_knowledge_* tools; here people
 * read and maintain the same entries.
 */
@Component({
    selector: 'kiwissen-settings',
    templateUrl: '../base.list.settings.html'
})
export class KiWissenSettings extends BaseListSettings {

    constructor(private translate: TranslateService, private standardService: StandardRequestBase, protected cdRef: ChangeDetectorRef) {
        super(cdRef);
    }

    getContentType() {
        return KiWissenDetail;
    }

    loadList(handler) {
        this.standardService.executeGet('api/settings/kiknowledge', 'search', 'limit=500').subscribe(result => {
            handler((result || []).map(entry => ({
                Caption: (entry.CapsuleTag ? '[' + entry.CapsuleTag + '] ' : '') + entry.Title,
                ID: entry.SID
            })));
        });
    }

    loadData(data) {
        this.standardService.executeGet('api/settings/kiknowledge', 'getentry', 'sid=' + data).subscribe(result => {
            if (result) {
                this.setSelectedItem(result);
            }
        });
    }

    getNewItem() {
        return {
            Title: this.translate.instant('@@Neuer Eintrag'),
            Text: '',
            Kind: 'note',
            Subject: '',
            CapsuleTag: null
        };
    }

    getDeleteText(sel): DeleteTexts {
        const retVal = new DeleteTexts();
        retVal.Question = new TranslateFormatText('@@Sind Sie sicher, dass Sie den Eintrag \'{0}\' loeschen moechten?');
        retVal.Question.FormatParams.push(sel.Caption);
        retVal.Success = new TranslateFormatText('@@Eintrag \'{0}\' erfolgreich geloescht.');
        retVal.Success.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Eintrag loeschen');
        return retVal;
    }

    getSaveSuccessText(sel): SaveTexts {
        const retVal = new SaveTexts();
        retVal.Text = new TranslateFormatText('@@Eintrag \'{0}\' erfolgreich gespeichert.');
        retVal.Text.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Eintrag speichern');
        return retVal;
    }

    delete(data, handler) {
        this.standardService.executeDelete('api/settings/kiknowledge', 'deleteentry', 'sid=' + data).subscribe((res) => {
            handler(res);
        });
    }

    saveInternal(item, handler) {
        this.standardService.executePost(item, 'api/settings/kiknowledge', 'saveentry').subscribe(result => {
            if (result) {
                handler(result, result, item.Title);
            }
        });
    }

    handleNew(item, result) {
        item.SID = result;
    }

    protected async checkCanSave(): Promise<DataCheck> {
        const retVal = new DataCheck();
        const sel = this.Component.SelectedItem;
        if (sel && (typeof sel.Title !== 'string' || sel.Title.trim() === '')) {
            retVal.IsCorrect = false;
            retVal.Error = this.translate.instant('@@Fehlender Titel');
        } else if (sel && (typeof sel.Text !== 'string' || sel.Text.trim() === '')) {
            retVal.IsCorrect = false;
            retVal.Error = this.translate.instant('@@Fehlender Text');
        }
        return retVal;
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@KI-Wissen',
            ID: 'kiwissen',
            Icon: 'description',
            Index: 62,
            Parent: 'settings',
            Security: {
                Name: 'evidanza.App.Shared.Security.PageSettingsRight',
                Value: 2
            },
            Content: KiWissenSettings
        };
    }
}

@Component({
    selector: 'kiwissen-detail',
    templateUrl: './kiwissen.settings.html'
})
export class KiWissenDetail extends BaseListDetail {
    Kinds = [
        { Value: 'rule', Caption: '@@Regel' },
        { Value: 'decision', Caption: '@@Entscheidung' },
        { Value: 'structure', Caption: '@@Aufbau' },
        { Value: 'todo', Caption: '@@Offen' },
        { Value: 'note', Caption: '@@Hinweis' },
    ];
}
